<template>
  <div class="weui_cell" :class="classes" @click="onClick">
    <div class="weui_cell_hd">
      <slot name="icon"></slot>
    </div>
    <div class="weui_cell_bd" :class="bdClasses">
      <p>
        {{title}}
        <slot name="after-title"></slot>
      </p>
      <inline-desc>{{inlineDesc}}</inline-desc>
    </div>
    <div class="weui_cell_ft" :class="{'weui_cell_primary':primary==='content'}">
      {{value}}
      <slot name="value"></slot>
      <slot></slot>
    </div>
    <div :class="{'with_arrow': isLink || !!link}"></div>
    <slot name="child"></slot>
  </div>
</template>

<script>
import InlineDesc from '../inline-desc'
import { go } from '../../libs/router'

export default {
  components: {
    InlineDesc
  },
  props: {
    bdStart: {
      type: Boolean,
      default: false
    },
    title: String,
    value: [String, Number],
    isLink: Boolean,
    inlineDesc: [String, Number],
    primary: {
      type: String,
      default: 'title'
    },
    link: {
      type: [String, Object]
    }
  },
  methods: {
    onClick () {
      go(this.link, this.$router)
    }
  },
  computed: {
    bdClasses () {
      return {
        'weui_cell_primary': this.primary === 'title'
      }
    },
    classes () {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui_cell_bd__start': this.bdStart
      }
    }
  }

}
</script>

<style lang="less">
@import '../../styles/variable.less';
@import '../../styles/tap.less';
@import '../../styles/cui/widget/cui_cell/cui_cell_global';
.weui_cell_bd__start {
  display: flex;
  align-items: flex-start!important;
}

.weui_cell_bd > p {
  color: @cell-body-label-color;
}
.with_arrow:after {
  content: " ";
  display: inline-block;
  transform: rotate(45deg);
  height: 8/@w;
  width: 8/@w;
  border-width: 1px 1px 0 0;
  border-color: #a0a0a0;
  border-style: solid;
  position: relative;
  top: -1px;
  margin-left: .3em;
}
</style>



// WEBPACK FOOTER //
// cell.vue?5b79d8ae